/**
 * Sign-up bonuses & promotions — `/betting-gaming/bonuses-promotions`
 */
import { BONUSES_PROMOTIONS_SLUG, bonusesPromotionsDefaultData } from "./bonusesPromotionsData";
import {
  BonusesPromotionsArticlesTab,
  BonusesPromotionsMediaTab,
  BonusesPromotionsOverviewTab,
} from "./BonusesPromotionsDesign";

export const bonusesPromotionsModule = {
  slug: BONUSES_PROMOTIONS_SLUG,
  getDefaultData: () => bonusesPromotionsDefaultData,
  Views: {
    overview: BonusesPromotionsOverviewTab,
    articles: BonusesPromotionsArticlesTab,
    media: BonusesPromotionsMediaTab,
  },
};
